import api from './api';
import {AllowedUser, ApiResponse, User} from './types';

/**
 * Users Service
 * Handles all user-related API requests
 */
const allowUsersLoginService = {
    /**
     * Get user by ID
     * @param id - User ID
     * @returns Promise<AllowedUser>
     */
    getById: async (id: string): Promise<AllowedUser> => {
        try {
            const response = await api.get<AllowedUser>(`/allowed-users/${id}`);
            return response;
        } catch (error) {
            console.error(`Error fetching user ${id}:`, error);
            throw error;
        }
    },

    /**
     * Get user by ID
     * @param email - User ID
     * @returns Promise<AllowedUser>
     */
    getByEmail: async (email: string): Promise<AllowedUser> => {
        try {
            const response = await api.get<AllowedUser>(`/allowed-users/email/${email}`);
            return response;
        } catch (error) {
            console.error(`Error fetching user ${email}:`, error);
            throw error;
        }
    },


    /**
     * Create new user
     * @returns Promise<AllowedUser>
     */

    create: async (userData: Partial<AllowedUser>): Promise<User> => {
        try {
            const response = await api.post<User>('/allowed-users', userData);
            return response;
        } catch (error) {
            console.error('Error creating user:', error);
            throw error;
        }
    },


    /**
     * Delete user
     * @param email - User ID
     * @returns Promise<void>
     */
    delete: async (email: string): Promise<void> => {
        try {
            await api.delete(`/allowed-users/email/${email}`);
        } catch (error) {
            console.error(`Error deleting user ${email}:`, error);
            throw error;
        }
    },




};

export default allowUsersLoginService;